const arIframes = document.querySelectorAll('iframe');
const mainHeaderEl = document.querySelector('.jsMainHeader');
const maxHeight = mainHeaderEl ? window.innerHeight - mainHeaderEl.offsetHeight : window.innerHeight * 0.9;

for (let i = 0; i < arIframes.length; i++) {
    const iframe = arIframes[i];
    const aspectRatio = getIframeAspectRatio(iframe);

    setIframeAspectRatio(iframe, aspectRatio);
    window.addEventListener('resize', _ => setIframeAspectRatio(iframe, aspectRatio));
    window.addEventListener('orientationchange', _ => setIframeAspectRatio(iframe, aspectRatio));
}

function setIframeAspectRatio(iFrameElement, ratio) {
    iFrameElement.style.height = Math.min(((iFrameElement.offsetWidth / ratio[0]) * ratio[1]), maxHeight) + 'px';
}

function getIframeAspectRatio(iframe) {
    const aspectRatio = iframe.dataset.aspectRatio;
    if (aspectRatio) return aspectRatio.split(':');

    if (iframe.getAttribute('width') && iframe.getAttribute('height')) {
        const definedWidth = iframe.getAttribute('width');
        const definedHeight = iframe.getAttribute('height');

        return [1, (definedHeight / definedWidth)];
    }

    return [16, 9];
}